import React from 'react';
import './Navbar.css';
import { RiHomeLine } from 'react-icons/ri';
import { RiUser3Line } from 'react-icons/ri';
import { BiBook } from 'react-icons/bi';
import { GrStackOverflow } from 'react-icons/gr';
import { BsChatLeftText } from 'react-icons/bs';

function Navbar() {
    return (
    <nav className="navbar">
      <a href="#presentation"><RiHomeLine /></a>
      <a href="#about"><RiUser3Line /></a>
      <a href="#skills"><GrStackOverflow /></a>
      <a href="#portfolio"><BiBook /></a>
      <a href="#contact"><BsChatLeftText /></a>
    </nav>
  )
}

export default Navbar;
